module.exports = __webpack_public_path__ + "static/media/kenji-kuno.566eacf4.png";